/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as TYPES from './ActionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setGenerateInvoiceSearchTab = (data) => {
  return {
    type: TYPES.GENERATE_INVOICE_SEARCH_TAB_DATA,
    generateInvoiceTabObj: data,
  };
};
export const setGenerateInvoiceDetailTab = (data) => {
  return {
    type: TYPES.GENERATE_INVOICE_DETAIL_TAB_DATA,
    generateInvDetailTabObj: data,
  };
};

export const handleErrorMesGenerateInvInRedux = (data) => ({
  type: TYPES.HANDLE_ERROR_MESSAGE_FOR_G_INV,
  errorMessagesInRedux: data,
});
export const dispatchQuarterData = (data) => ({
  type: TYPES.GET_QUARTER_DATA_G_INV,
  quarter: data,
});
export const setPervSearchScreenTabDataRedux = (data) => {
  return {
    type: TYPES.PERV_SEARCH_SCREEN_DATA,
    perviousSearchScreenDataRedux: data,
  };
};
export const getQuarterData = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MAX_QTR_FOR_INV_SEARCH)
    .then((response) => {
      return dispatch(
        dispatchQuarterData(response.data && response?.data?.data)
      );
    })
    .catch(() => {
      dispatch(dispatchQuarterData(''));
    });
};
export const dispatchCommonDropdownData = (data) => ({
  type: TYPES.GET_COMMON_DROPDOWN_DATA_G_INV,
  dropdown: data,
});

export const getCommonDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchPlanTypeFilterData = (data) => ({
  type: TYPES.GET_PLAN_TYPE_DATA_G_INV,
  planTypeRadioList: data,
});
export const getPlanTypeRadioBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanTypeFilterData(response.data));
    })
    .catch(() => {
      dispatch(dispatchPlanTypeFilterData([]));
    });
};
export const dispatchGenerateInvoiceCriteriaList = (data) => ({
  type: TYPES.GET_SEARCH_G_INV_BY_CRITERIA,
  generateInvoiceGridVOList: data,
});
const isCreateDtNewerThanUpload = (createDt, uploadedDt) => {
  if (!createDt) {
    return false;
  }
  if (!uploadedDt) {
    return true;
  }
  return new Date(uploadedDt) < new Date(createDt);
};

const normalizeGenerateInvoiceGridData = (gridData = [], actionType) => {
  if (!gridData?.length) {
    return [];
  }
  return gridData.map((item) => {
    const normalizedItem = { ...item };

    if (actionType === 1 && !normalizedItem.printImageCreateDt) {
      if (Number(normalizedItem.useDefMfgInd) === 1) {
        normalizedItem.printImageInd = normalizedItem.defPrintImageInd;
        normalizedItem.defCmsElectInd =  normalizedItem.defCmsElectInd;
        normalizedItem.defNcpdpSummaryInd =  normalizedItem.defNcpdpSummaryInd;
        normalizedItem.defNcpdpClaimOwnInd =  normalizedItem.defNcpdpClaimOwnInd;
      }

      if (Number(normalizedItem.useDefMfgInd) === 0) {
        normalizedItem.defCmsElectInd =  normalizedItem.cmsElectInd;
        normalizedItem.defNcpdpSummaryInd =  normalizedItem.ncpdpSummaryInd;
        normalizedItem.defNcpdpClaimOwnInd =  normalizedItem.ncpdpClaimOwnInd;
        normalizedItem.printImageInd =  normalizedItem.printImageInd;
      }
    }

    if (actionType === 1 && normalizedItem.printImageCreateDt) {
      if (
        isCreateDtNewerThanUpload(
          normalizedItem.printImageCreateDt,
          normalizedItem.invoiceUploadedDt
        )
      ) {
        normalizedItem.printImageInd = 0;
      }
      if (
        isCreateDtNewerThanUpload(
          normalizedItem.cmsElectCreateDt,
          normalizedItem.invoiceUploadedDt
        )
      ) {
        normalizedItem.defCmsElectInd = 0;
      }
      if (
        isCreateDtNewerThanUpload(
          normalizedItem.ncpdpSummaryCreateDt,
          normalizedItem.invoiceUploadedDt
        )
      ) {
        normalizedItem.defNcpdpSummaryInd = 0;
      }
      if (
        isCreateDtNewerThanUpload(
          normalizedItem.ncpdpClaimOwnCreateDt,
          normalizedItem.invoiceUploadedDt
        )
      ) {
        normalizedItem.defNcpdpClaimOwnInd = 0;
      }
      if (
        isCreateDtNewerThanUpload(
          normalizedItem.ncpdpClaimMbCreateDt,
          normalizedItem.invoiceUploadedDt
        )
      ) {
        normalizedItem.defNcpdpClaimMbInd = 0;
      }
    }

    if (actionType === 2) {
      if (Number(normalizedItem.useDefMfgInd) === 1) {
        normalizedItem.printImageInd = normalizedItem.defPrintImageInd;
        normalizedItem.defCmsElectInd = normalizedItem.defCmsElectInd;
        normalizedItem.defNcpdpSummaryInd = normalizedItem.defNcpdpSummaryInd;
        normalizedItem.defNcpdpClaimOwnInd = normalizedItem.defNcpdpClaimOwnInd;
        normalizedItem.defNcpdpClaimMbInd = normalizedItem.defNcpdpClaimMbInd;
      }

      if (Number(normalizedItem.useDefMfgInd) === 0) {
        normalizedItem.defCmsElectInd = normalizedItem.cmsElectInd;
        normalizedItem.defNcpdpSummaryInd = normalizedItem.ncpdpSummaryInd;
        normalizedItem.defNcpdpClaimOwnInd = normalizedItem.ncpdpClaimOwnInd;
        normalizedItem.printImageInd = normalizedItem.printImageInd;
        normalizedItem.defNcpdpClaimMbInd = normalizedItem.ncpdpClaimMbInd;
      }

      const invoiceNotUploaded = !normalizedItem.invoiceUploadedDt;

      if (!normalizedItem.printImageCreateDt) {
        normalizedItem.printImageInd = 0;
      } else if (invoiceNotUploaded) {
        normalizedItem.printImageInd = 1;
      }
      if (!normalizedItem.cmsElectCreateDt) {
        normalizedItem.defCmsElectInd = 0;
      } else if (invoiceNotUploaded) {
        normalizedItem.defCmsElectInd = 1;
      }
      if (!normalizedItem.ncpdpSummaryCreateDt) {
        normalizedItem.defNcpdpSummaryInd = 0;
      } else if (invoiceNotUploaded) {
        normalizedItem.defNcpdpSummaryInd = 1;
      }
      if (!normalizedItem.ncpdpClaimOwnCreateDt) {
        normalizedItem.defNcpdpClaimOwnInd = 0;
      } else if (invoiceNotUploaded) {
        normalizedItem.defNcpdpClaimOwnInd = 1;
      }
      if (!normalizedItem.ncpdpClaimMbCreateDt) {
        normalizedItem.defNcpdpClaimMbInd = 0;
      } else if (invoiceNotUploaded) {
        normalizedItem.defNcpdpClaimMbInd = 1;
      }
    }

    return normalizedItem;
  });
};
export const getSearchGenerateInvByCriteriaList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_GENERATE_INVOICE_GRID_LIST, value)
    .then((response) => {
      const gridData = response?.data?.generateInvoiceGridVOList || [];
      const actionType = value?.action;
      return dispatch(
        dispatchGenerateInvoiceCriteriaList(
          normalizeGenerateInvoiceGridData(gridData, actionType)
        )
      );
    })
    .catch(() => {
      dispatch(dispatchGenerateInvoiceCriteriaList([]));
    });
};
export const getRunNowResult = (data) => ({
  type: TYPES.GET_RUN_NOW_GI,
  runApiResult: data,
});
export const callRunApi = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.PROCESS_GENERATE_INVOICES, value)
    .then((response) => {
      return dispatch(getRunNowResult(response?.data));
    })
    .catch((err) => {
      if (err?.response?.status == 400) {
        dispatch(getRunNowResult(err.response?.data));
        return;
      }
      dispatch(getRunNowResult({ status: '003' }));
    });
};
export const setPdfInvoice = (data) => {
  return {
    type: TYPES.PDF_RUN_NOW_GI,
    pdfPrev: data,
  };
};

export const dispatchUpdateCustomizeLetter = (values) => {
  return {
    customizeLetterMsg: values,
    type: TYPES.UPDATE_CUSTOMIZE_LETTER,
  };
};
export const postUpdateCustomizeLetter = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CUSTOMIZE_LETTER, value)
    .then((response) => {
      return dispatch(
        dispatchUpdateCustomizeLetter({
          ...response.data,
          message: 'SUCCESS',
        })
      );
    })
    .catch(() => {
      dispatch(dispatchUpdateCustomizeLetter('failed'));
    });
};
export const getResumeInvoicePrintList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_GENERATE_INVOICE_RESUME_PRINT, value)
    .then((response) => {
      return dispatch(
        dispatchGenerateInvoiceCriteriaList(
          response?.data?.generateInvoicePrintList
        )
      );
    })
    .catch(() => {
      dispatch(dispatchGenerateInvoiceCriteriaList([]));
    });
};
export const dispatchGetPlanTypeCd = (values) => {
  return {
    planTypeCd: values,
    type: TYPES.GET_PLAN_TYPE_USING_REBATE_PROG,
  };
};
export const getPlanTypeCdUsingRebateProg = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PLAN_TYPE_BY_REBATE_PROGRAM, value)
    .then((response) => {
      return dispatch(dispatchGetPlanTypeCd(response?.data?.planTypeCd));
    })
    .catch(() => {
      dispatch(dispatchGetPlanTypeCd([]));
    });
};
export const clearReduxForGenerateSearchScreen = () => (dispatch) => {
  dispatch(setGenerateInvoiceSearchTab({}));
  dispatch(handleErrorMesGenerateInvInRedux([]));
  dispatch(dispatchQuarterData(''));
  // dispatch(dispatchPlanTypeFilterData({}));
  dispatch(dispatchGenerateInvoiceCriteriaList([]));
};
export const clearReduxForGenerateDetailScreen = () => (dispatch) => {
  dispatch(setGenerateInvoiceDetailTab([]));
  dispatch(setPervSearchScreenTabDataRedux([]));
  dispatch(dispatchGetPlanTypeCd(''));
  dispatch(setPdfInvoice(''));
};
export const getPrintPreview = (value) => (dispatch) => {
  return axios
    .post(
      value?.printJustMailingLabels && value?.action === 0
        ? serviceEndPoint.GENERATE_MAIL_LABLE_INVOICE
        : serviceEndPoint.GEN_PDF_GEN_INVOICE,
      value,
      {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/octet-stream',
        },
      }
    )
    .then((response) => {
      return dispatch(setPdfInvoice(response.data));
    })
    .catch(() => {
      dispatch(setPdfInvoice('failed'));
    });
};
// Save the failed invoices in DB after print pdf
export const dispatchSaveFailedInvoice = (values) => {
  return {
    saveFailedInvoice: values,
    type: TYPES.SAVE_FAILED_INVOICES,
  };
};
export const saveFailedInvoice = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_FAILED_INVOICES, value)
    .then((response) => {
      return dispatch(dispatchSaveFailedInvoice(response.data));
    })
    .catch(() => {
      dispatch(dispatchSaveFailedInvoice('failed'));
    });
};
export const remotePrintInvoice = (value) => () => {
  return axios
    .post(serviceEndPoint.REMOTE_PRINT_INVOICE, value)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return err.response?.data || { status: '003' };
    });
};
